import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectItem } from 'store/property/propertyActions';
import { getPayWith } from 'store/checkout/checkoutSelectors';
import { getResultCount } from 'store/search/searchSelectors';
import { getPointsConversion } from 'store/pointsBurnTiers/pointsBurnSelectors';
import {
  getQueryCheckIn,
  getQueryCheckOut,
  getQueryAdults,
  getQueryChildren,
  getQueryInfants,
  getQueryLocation,
} from 'store/router/routerSelectors';
import { fetchPointsBurnTiers } from 'store/pointsBurnTiers/pointsBurnActions';
import { throttle } from 'lodash';

export default function useSelectItemEvent() {
  const dispatch = useDispatch();
  const location = useSelector(getQueryLocation);
  const payWith = useSelector(getPayWith);
  const resultCount = useSelector(getResultCount) ?? 0;
  const checkIn = useSelector(getQueryCheckIn);
  const checkOut = useSelector(getQueryCheckOut);
  const adults = useSelector(getQueryAdults);
  const children = useSelector(getQueryChildren);
  const infants = useSelector(getQueryInfants);
  const pointsConversion = useSelector(getPointsConversion);
  const hasLevels = !!pointsConversion?.levels?.length;

  useEffect(() => {
    if (!hasLevels) {
      dispatch(fetchPointsBurnTiers());
    }
  }, [dispatch, hasLevels]);

  const onFireEvent = (props) => {
    dispatch(
      selectItem({
        category: 'qantas',
        location,
        payWith,
        availableProperties: resultCount,
        query: {
          checkIn,
          checkOut,
          adults,
          children,
          infants,
        },
        pointsConversion,
        ...props,
      }),
    );
  };

  const fireSelectItemEvent = throttle(onFireEvent, 150);

  return { fireSelectItemEvent };
}
